import { isToday } from 'date-fns';
import { ColumnDefinitionEnumType } from '@mark43/cad-api';
import { Tooltip } from '../../../common/components/tooltip';
import columnDefinitionEnum from '../../../queues/column-definition.enum';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { getClockTime } from '../../../queues/utils/get-clock-time';
import { getFormattedDate } from '../../../queues/utils/get-formatted-date';

/**
 * If the date is today, display the time.
 * If the date isn't today, disply both date and time.
 */
export function TodayTimeCell({
    dateStr,
    columnDefinitionName,
}: {
    dateStr: string | undefined;
    columnDefinitionName: ColumnDefinitionEnumType;
}): React.ReactElement {
    if (!dateStr) {
        return <BaseQueueCell />;
    }
    const dateIsToday = isToday(new Date(dateStr));
    const columnDefinition = columnDefinitionEnum[columnDefinitionName];
    const contentAlignment =
        'contentAlignment' in columnDefinition ? columnDefinition.contentAlignment : undefined;
    return (
        <Tooltip overlay={getFormattedDate(dateStr)}>
            <BaseQueueCell alignment={contentAlignment ?? 'CENTER'}>
                {dateIsToday ? getClockTime(dateStr) : getFormattedDate(dateStr)}
            </BaseQueueCell>
        </Tooltip>
    );
}
